(function () {
  'use strict';

  const QUIZ_PRODUCTS = {
    'rosemary-serum': { handle: 'rosemary-scalp-and-roots-serum-hair-force-50-ml', title: 'Rosemary Scalp & Roots Serum', desc: '50ml' },
    'rosemary-booster': { handle: 'rosemary-scalp-and-roots-mist-booster-150-ml', title: 'Rosemary Mist Booster', desc: '150ml' },
    'botanical-shampoo': { handle: 'botanical-hair-shampoo-500-ml', title: 'Botanical Hair Shampoo', desc: '500ml' },
    'botanical-conditioner': { handle: 'botanical-hair-conditioner-500-ml', title: 'Botanical Hair Conditioner', desc: '500ml' },
    'hair-mask': { handle: 'botanical-hair-mask-240-ml', title: 'Botanical Hair Mask', desc: '240ml' },
    'hair-miracle': { handle: 'hair-miracle-oil-150-ml', title: 'Hair Miracle Oil', desc: '150ml' },
    'white-musk-spray': { handle: 'white-musk-spray', title: 'White Musk Hair & Body Spray', desc: '' },
    'almond-milk-spray': { handle: 'almond-milk-hair-and-body-spray-100-ml', title: 'Almond Milk Hair & Body Spray', desc: '100ml' },
    'dads-garden-spray': { handle: 'dads-garden-hair-and-body-spray-100-ml', title: "Dad's Garden Hair & Body Spray", desc: '100ml' },
    'instant-glow': { handle: 'instant-glow-rose-hibiscus-50g', title: 'Instant Glow Rose & Hibiscus', desc: '50g' },
    'rose-foam': { handle: 'rose-cleansing-foam-150-ml', title: 'Rose Cleansing Foam', desc: '150ml' },
    'vitamin-e': { handle: 'vitamin-e-botanical-calendula-nerolli-jojoba-30ml', title: 'Vitamin E Botanical', desc: '30ml' },
    'rose-toner': { handle: 'rose-mist-toner-150-ml', title: 'Rose Mist Toner', desc: '150ml' },
    'body-lotion-white-musk': { handle: 'shea-white-musk-body-lotion-250-ml', title: 'Shea White Musk Body Lotion', desc: '250ml' },
    'body-lotion-floral': { handle: 'shea-floral-body-lotion-250-ml', title: 'Shea Floral Body Lotion', desc: '250ml' },
    'body-lotion-almond': { handle: 'shea-almond-milk-body-lotion-250-ml', title: 'Shea Almond Milk Body Lotion', desc: '250ml' },
    'jasmine-body-oil': { handle: 'jasmine-body-oil-140-ml', title: 'Jasmine Body Oil', desc: '140ml' },
    'lavender-body-oil': { handle: 'lavender-body-oil-140-ml', title: 'Lavender Body Oil', desc: '140ml' },
    'body-wash-verbena': { handle: 'botanical-verbena-hydrating-body-wash-500-ml', title: 'Botanical Verbena Body Wash', desc: '500ml' },
    'body-wash-floral': { handle: 'botanical-floral-hydrating-body-wash-500-ml', title: 'Botanical Floral Body Wash', desc: '500ml' },
    'coffee-scrub': { handle: 'coffee-scrub-250-g', title: 'Coffee Scrub', desc: '250g' },
    'cellulite-oil': { handle: 'cellulite-oil-125-ml', title: 'Cellulite Oil', desc: '125ml' },
    'beard-oil': { handle: 'beard-oil-30-ml', title: 'Beard Oil', desc: '30ml' },
  };

  const CONCERN_PRODUCTS = {
    'hair-loss': ['rosemary-serum', 'rosemary-booster', 'botanical-shampoo'],
    'dandruff': ['botanical-shampoo'],
    'shine-repair': ['botanical-shampoo', 'botanical-conditioner', 'hair-mask', 'hair-miracle'],
    'hair-odor': ['white-musk-spray', 'almond-milk-spray', 'dads-garden-spray'],
    'hydration-antiaging': ['instant-glow', 'rose-foam', 'rose-toner', 'vitamin-e'],
    'acne-blemishes': ['rose-foam', 'rose-toner', 'instant-glow'],
    'redness': ['rose-toner', 'rose-foam'],
    'brightening': ['vitamin-e', 'rose-toner', 'rose-foam'],
    'body-dry': ['body-lotion-white-musk', 'body-lotion-almond', 'jasmine-body-oil', 'coffee-scrub', 'white-musk-spray'],
    'body-sensitive': ['body-lotion-floral', 'body-lotion-almond', 'body-wash-floral'],
    'body-cellulite': ['cellulite-oil', 'coffee-scrub'],
    'body-odor': ['body-wash-verbena', 'body-wash-floral', 'coffee-scrub', 'white-musk-spray'],
    'body-dull': ['body-lotion-white-musk', 'jasmine-body-oil', 'body-wash-verbena', 'coffee-scrub', 'almond-milk-spray'],
    'men-hair': ['rosemary-serum', 'rosemary-booster', 'botanical-shampoo'],
    'men-body': ['body-wash-verbena', 'jasmine-body-oil', 'coffee-scrub'],
    'men-facial': ['rose-foam', 'rose-toner', 'vitamin-e'],
    'men-beard': ['beard-oil'],
  };

  const productCache = {};

  async function fetchProductData(handle) {
    if (productCache[handle]) return productCache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      productCache[handle] = data;
      return data;
    } catch (e) { return null; }
  }

  let quizState = {
    category: null,
    step1: null,
    concern: null,
    selectedProducts: new Set(),
    productVariants: {},
  };

  async function renderProductCard(key) {
    const product = QUIZ_PRODUCTS[key];
    if (!product) return null;
    const data = await fetchProductData(product.handle);

    let imgHtml = `<div class="card-img-placeholder">${product.title.charAt(0)}</div>`;
    let priceHtml = '';

    if (data) {
      if (data.images && data.images.length > 0) {
        imgHtml = `<img class="card-img" src="${data.images[0]}" alt="${data.title}" loading="lazy">`;
      }
      if (data.variants && data.variants.length > 0) {
        const variantId = data.variants[0].id;
        const price = (data.variants[0].price / 100).toFixed(2);
        priceHtml = `<div class="card-price">$${price}</div>`;
        quizState.productVariants[product.handle] = variantId;
      }
    }

    const div = document.createElement('div');
    div.className = 'nour-product-card';
    div.dataset.key = key;
    div.innerHTML = `
      <div class="card-check"></div>
      ${imgHtml}
      <div class="card-body">
        <div class="card-title">${data ? data.title : product.title}</div>
        ${product.desc ? `<div class="card-desc">${product.desc}</div>` : ''}
        ${priceHtml}
      </div>
    `;
    div.addEventListener('click', () => toggleProductCard(div, key));
    return div;
  }

  async function renderChatProductCard(handle) {
    const data = await fetchProductData(handle);
    if (!data) return null;

    const price = data.variants && data.variants.length > 0
      ? `$${(data.variants[0].price / 100).toFixed(2)}` : '';
    const img = data.images && data.images.length > 0
      ? `<img src="${data.images[0]}" alt="${data.title}" style="width:100%;height:90px;object-fit:cover;border-radius:6px 6px 0 0;">`
      : `<div style="width:100%;height:90px;background:#f5f5f5;border-radius:6px 6px 0 0;display:flex;align-items:center;justify-content:center;font-size:1.4rem;color:#666;">${data.title.charAt(0)}</div>`;

    const card = document.createElement('a');
    card.href = `/products/${handle}`;
    card.target = '_blank';
    card.style.cssText = 'display:block;border:1px solid #ddd;border-radius:8px;overflow:hidden;text-decoration:none;color:inherit;background:white;transition:box-shadow 0.2s;min-width:130px;max-width:150px;flex-shrink:0;';
    card.onmouseenter = () => card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
    card.onmouseleave = () => card.style.boxShadow = 'none';
    card.innerHTML = `
      ${img}
      <div style="padding:8px;">
        <div style="font-size:1.1rem;font-weight:600;color:#111;line-height:1.3;margin-bottom:4px;">${data.title}</div>
        ${price ? `<div style="font-size:1.1rem;color:#111;">${price}</div>` : ''}
        <div style="margin-top:6px;background:#111;color:white;text-align:center;padding:5px 8px;border-radius:4px;font-size:1rem;font-weight:600;letter-spacing:0.05em;">View</div>
      </div>
    `;
    return card;
  }

  function toggleProductCard(card, key) {
    if (quizState.selectedProducts.has(key)) {
      quizState.selectedProducts.delete(key);
      card.classList.remove('selected');
    } else {
      quizState.selectedProducts.add(key);
      card.classList.add('selected');
    }
    updateAddButton();
  }

  function updateAddButton() {
    const btn = document.getElementById('nour-add-selected-btn');
    if (!btn) return;
    const count = quizState.selectedProducts.size;
    btn.disabled = count === 0;
    btn.textContent = count === 0 ? 'Select products above' : count === 1 ? 'Add to Cart' : `Add ${count} Products to Cart`;
  }

  async function addSelectedToCart() {
    const btn = document.getElementById('nour-add-selected-btn');
    const feedback = document.getElementById('nour-cart-feedback');
    btn.disabled = true;
    btn.textContent = 'Adding...';

    const items = [];
    for (const key of quizState.selectedProducts) {
      const product = QUIZ_PRODUCTS[key];
      let variantId = quizState.productVariants[product.handle];
      if (!variantId) {
        const data = await fetchProductData(product.handle);
        if (data && data.variants && data.variants.length > 0) variantId = data.variants[0].id;
      }
      if (variantId) items.push({ id: variantId, quantity: 1 });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (res.ok) {
        feedback.textContent = `${items.length} item${items.length > 1 ? 's' : ''} added to your cart!`;
        feedback.classList.add('show');
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.querySelector('span:not(.visually-hidden)').textContent = cartData.item_count;
        setTimeout(() => {
          feedback.classList.remove('show');
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }, 1500);
      } else {
        feedback.textContent = 'Something went wrong. Please try again.';
        feedback.classList.add('show');
        btn.disabled = false;
        updateAddButton();
      }
    } catch (e) {
      feedback.textContent = 'Something went wrong. Please try again.';
      feedback.classList.add('show');
      btn.disabled = false;
      updateAddButton();
    }
  }

  function goToStep(stepId) {
    document.querySelectorAll('.nour-quiz-step').forEach(s => s.classList.remove('active'));
    const target = document.getElementById(stepId);
    if (target) target.classList.add('active');
    updateProgress(stepId);
    const quizPage = document.querySelector('.nour-quiz-page');
    if (quizPage) window.scrollTo({ top: quizPage.offsetTop - 20, behavior: 'smooth' });
  }

  function updateProgress(stepId) {
    const bar = document.getElementById('nour-progress-bar');
    const fill = document.getElementById('nour-progress-fill');
    const label = document.getElementById('nour-progress-label');
    if (stepId === 'step-landing') { bar && bar.classList.remove('visible'); return; }
    bar && bar.classList.add('visible');
    const steps = { 'step-type': 1, 'step-concern': 2, 'step-results': 3 };
    const current = steps[stepId] || 1;
    if (fill) fill.style.width = Math.round((current / 3) * 100) + '%';
    if (label) label.textContent = `${current} / 3`;
  }

  async function showResults(concernKey, routineLabel) {
    quizState.concern = concernKey;
    quizState.selectedProducts.clear();
    quizState.productVariants = {};
    const productKeys = CONCERN_PRODUCTS[concernKey] || [];
    const grid = document.getElementById('nour-products-grid');
    if (!grid) return;
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:30px;color:#666;font-size:1.4rem;">Loading your routine...</div>';
    goToStep('step-results');
    const subtitle = document.getElementById('nour-results-subtitle');
    if (subtitle) subtitle.textContent = routineLabel || 'Personalized just for you';
    grid.innerHTML = '';
    const cards = await Promise.all(productKeys.map(key => renderProductCard(key)));
    cards.filter(Boolean).forEach(card => grid.appendChild(card));
    updateAddButton();
  }

  function restartQuiz() {
    quizState = { category: null, step1: null, concern: null, selectedProducts: new Set(), productVariants: {} };
    goToStep('step-landing');
    const feedback = document.getElementById('nour-cart-feedback');
    if (feedback) feedback.classList.remove('show');
  }

  function getTypeOptions(category) {
    const map = {
      hair: [
        { value: 'dry-frizzy', label: 'Dry & Frizzy' },
        { value: 'oily', label: 'Oily' },
        { value: 'normal', label: 'Normal' },
        { value: 'curly', label: 'Curly' },
        { value: 'color-treated', label: 'Color-Treated' },
      ],
      facial: [
        { value: 'oily-skin', label: 'Oily Skin' },
        { value: 'dry-skin', label: 'Dry Skin' },
        { value: 'normal-skin', label: 'Normal Skin' },
        { value: 'sensitive-skin', label: 'Sensitive Skin' },
      ],
      body: [
        { value: 'dry-skin', label: 'Dry Skin' },
        { value: 'sensitive-skin', label: 'Sensitive Skin' },
        { value: 'normal-skin', label: 'Normal Skin' },
      ],
    };
    return map[category] || [];
  }

  function getConcernOptions(category) {
    const map = {
      hair: [
        { value: 'hair-loss', label: 'Hair Loss' },
        { value: 'dandruff', label: 'Dandruff' },
        { value: 'shine-repair', label: 'Shine & Repair' },
        { value: 'hair-odor', label: 'Hair Odor' },
      ],
      facial: [
        { value: 'hydration-antiaging', label: 'Hydration & Anti-Aging' },
        { value: 'acne-blemishes', label: 'Acne & Blemishes' },
        { value: 'redness', label: 'Redness' },
        { value: 'brightening', label: 'Brightening' },
      ],
      body: [
        { value: 'body-dry', label: 'Dry Skin' },
        { value: 'body-sensitive', label: 'Sensitive Skin' },
        { value: 'body-cellulite', label: 'Cellulite & Stretch Marks' },
        { value: 'body-odor', label: 'Body Odor' },
        { value: 'body-dull', label: 'Dull Skin' },
      ],
      men: [
        { value: 'men-hair', label: 'Hair' },
        { value: 'men-body', label: 'Body' },
        { value: 'men-facial', label: 'Facial' },
        { value: 'men-beard', label: 'Beard' },
      ],
    };
    return map[category] || [];
  }

  function renderOptions(listId, options, onClick) {
    const list = document.getElementById(listId);
    if (!list) return;
    list.innerHTML = options.map(o => `<button class="nour-option-btn" data-value="${o.value}" data-label="${o.label}">${o.label}</button>`).join('');
    list.querySelectorAll('.nour-option-btn').forEach(btn => {
      btn.addEventListener('click', () => onClick(btn.dataset.value, btn.dataset.label));
    });
  }

  function initQuiz() {
    document.querySelectorAll('.nour-category-card[data-category]').forEach(card => {
      card.addEventListener('click', () => {
        quizState.category = card.dataset.category;
        const typeTitle = document.getElementById('step-type-title');

        if (quizState.category === 'men') {
          if (typeTitle) typeTitle.textContent = 'What are you looking for?';
          renderOptions('step-type-options', getConcernOptions('men'), (value, label) => {
            showResults(value, label);
          });
          goToStep('step-type');
        } else {
          const titles = { hair: 'What is your hair type?', facial: 'What is your skin type?', body: 'What is your skin type?' };
          if (typeTitle) typeTitle.textContent = titles[quizState.category] || 'What is your type?';
          renderOptions('step-type-options', getTypeOptions(quizState.category), (value) => {
            quizState.step1 = value;
            const concernTitle = document.getElementById('step-concern-title');
            const titles2 = { hair: 'What is your hair concern?', facial: 'What is your skin concern?', body: 'What is your body concern?' };
            if (concernTitle) concernTitle.textContent = titles2[quizState.category] || 'What is your concern?';
            renderOptions('step-concern-options', getConcernOptions(quizState.category), (cValue, cLabel) => {
              showResults(cValue, cLabel);
            });
            goToStep('step-concern');
          });
          goToStep('step-type');
        }
      });
    });

    document.querySelectorAll('.nour-back-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.backTo;
        if (target) goToStep(target);
      });
    });

    const addBtn = document.getElementById('nour-add-selected-btn');
    if (addBtn) addBtn.addEventListener('click', addSelectedToCart);

    const restartBtn = document.getElementById('nour-restart-btn');
    if (restartBtn) restartBtn.addEventListener('click', restartQuiz);
  }

  const NOUR_SYSTEM = `You are Nour, a warm and knowledgeable beauty advisor for Oils of Nature — a Lebanese artisan beauty brand specializing in natural, plant-based products.

Your personality: friendly, knowledgeable, warm, genuinely caring. Speak like a trusted friend who happens to be a beauty expert. Keep responses concise (2-4 sentences) and conversational.

IMPORTANT: You MUST always respond in this exact JSON format:
{
  "message": "Your friendly response text here",
  "products": ["product-handle-1", "product-handle-2"]
}

If no products to recommend, use empty array:
{
  "message": "Your friendly response text here",
  "products": []
}

Available products and their handles:
- rosemary-scalp-and-roots-serum-hair-force-50-ml (hair loss, hair growth, scalp care)
- rosemary-scalp-and-roots-mist-booster-150-ml (scalp nourishment, hair growth boost)
- botanical-hair-shampoo-500-ml (gentle cleansing, dandruff, all hair types)
- botanical-hair-conditioner-500-ml (moisture, softness, shine)
- botanical-hair-mask-240-ml (deep repair, damaged hair)
- hair-miracle-oil-150-ml (shine, frizz control, repair)
- white-musk-spray (fragrance, freshness, hair and body)
- almond-milk-hair-and-body-spray-100-ml (nourishing fragrance)
- dads-garden-hair-and-body-spray-100-ml (fresh scent)
- instant-glow-rose-hibiscus-50g (brightening, glow, exfoliation)
- rose-cleansing-foam-150-ml (gentle face wash, acne, sensitive skin)
- vitamin-e-botanical-calendula-nerolli-jojoba-30ml (anti-aging, hydration, skin repair)
- rose-mist-toner-150-ml (hydration, redness, toning, acne)
- shea-white-musk-body-lotion-250-ml (dry skin, moisturizing)
- shea-floral-body-lotion-250-ml (sensitive skin, moisturizing)
- shea-almond-milk-body-lotion-250-ml (nourishing, dry skin)
- jasmine-body-oil-140-ml (dry skin, luxury, scented)
- lavender-body-oil-140-ml (relaxing, dry skin)
- botanical-verbena-hydrating-body-wash-500-ml (cleansing, refreshing)
- botanical-floral-hydrating-body-wash-500-ml (sensitive skin, gentle)
- coffee-scrub-250-g (exfoliation, cellulite, dull skin)
- cellulite-oil-125-ml (cellulite, stretch marks)
- beard-oil-30-ml (beard care, men)

Always respond in the same language the user writes in (Arabic or English).
Always respond in valid JSON only. No extra text outside the JSON.`;

  function initChatbot() {
    const trigger = document.getElementById('nour-chatbot-trigger');
    const chatWindow = document.getElementById('nour-chatbot-window');
    const closeBtn = document.getElementById('nour-chat-close');
    const input = document.getElementById('nour-chat-input');
    const sendBtn = document.getElementById('nour-chat-send');
    const messages = document.getElementById('nour-chat-messages');

    if (!trigger || !chatWindow) return;

    trigger.addEventListener('click', () => {
      chatWindow.classList.toggle('open');
      if (chatWindow.classList.contains('open')) {
        input && input.focus();
        const badge = document.getElementById('nour-chatbot-badge');
        if (badge) badge.style.display = 'none';
      }
    });

    closeBtn && closeBtn.addEventListener('click', () => chatWindow.classList.remove('open'));

    const chatHistory = [];

    async function sendMessage() {
      const text = input.value.trim();
      if (!text) return;
      input.value = '';
      appendUserMessage(text);
      const typing = appendTyping();

      try {
        const response = await fetch('https://nour-proxy.henrihankache9.workers.dev', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            model: 'claude-sonnet-4-5',
            max_tokens: 1000,
            system: NOUR_SYSTEM,
            messages: [...chatHistory, { role: 'user', content: text }],
          }),
        });

        const data = await response.json();
        typing.remove();

        const rawReply = data.content && data.content[0] ? data.content[0].text : null;

        if (rawReply) {
          try {
            const clean = rawReply.replace(/```json|```/g, '').trim();
            const parsed = JSON.parse(clean);
            await appendBotMessage(parsed.message || rawReply, parsed.products || []);
            chatHistory.push({ role: 'user', content: text });
            chatHistory.push({ role: 'assistant', content: rawReply });
          } catch (e) {
            appendPlainBotMessage(rawReply);
            chatHistory.push({ role: 'user', content: text });
            chatHistory.push({ role: 'assistant', content: rawReply });
          }
        } else {
          appendPlainBotMessage("I'm sorry, I couldn't process that. Please try again!");
        }
      } catch (e) {
        typing.remove();
        appendPlainBotMessage("I'm having trouble connecting right now. Please try again in a moment.");
      }
    }

    sendBtn && sendBtn.addEventListener('click', sendMessage);
    input && input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });

    function appendUserMessage(text) {
      const msg = document.createElement('div');
      msg.className = 'chat-msg user';
      msg.innerHTML = `<div class="msg-bubble">${text}</div>`;
      messages.appendChild(msg);
      messages.scrollTop = messages.scrollHeight;
    }

    async function appendBotMessage(text, productHandles) {
      const msg = document.createElement('div');
      msg.className = 'chat-msg bot';
      msg.style.maxWidth = '95%';
      msg.style.flexDirection = 'column';

      const topRow = document.createElement('div');
      topRow.style.cssText = 'display:flex;gap:8px;align-items:flex-start;';
      topRow.innerHTML = `<div class="msg-avatar">N</div><div class="msg-bubble" style="flex:1;">${text}</div>`;
      msg.appendChild(topRow);

      if (productHandles && productHandles.length > 0) {
        const cardsContainer = document.createElement('div');
        cardsContainer.style.cssText = 'display:flex;gap:8px;overflow-x:auto;padding:8px 0 4px 36px;margin-top:4px;';
        cardsContainer.style.scrollbarWidth = 'none';

        const cards = await Promise.all(productHandles.map(h => renderChatProductCard(h)));
        cards.filter(Boolean).forEach(card => cardsContainer.appendChild(card));
        msg.appendChild(cardsContainer);
      }

      messages.appendChild(msg);
      messages.scrollTop = messages.scrollHeight;
      return msg;
    }

    function appendPlainBotMessage(text) {
      const msg = document.createElement('div');
      msg.className = 'chat-msg bot';
      msg.innerHTML = `<div class="msg-avatar">N</div><div class="msg-bubble">${text}</div>`;
      messages.appendChild(msg);
      messages.scrollTop = messages.scrollHeight;
      return msg;
    }

    function appendTyping() {
      const msg = document.createElement('div');
      msg.className = 'chat-msg bot';
      msg.innerHTML = `<div class="msg-avatar">N</div><div class="chat-typing"><span></span><span></span><span></span></div>`;
      messages.appendChild(msg);
      messages.scrollTop = messages.scrollHeight;
      return msg;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initQuiz();
    initChatbot();
  });

})();